import { render, staticRenderFns } from "./RightsCard.vue?vue&type=template&id=5251d128&scoped=true"
import script from "./RightsCard.vue?vue&type=script&lang=js"
export * from "./RightsCard.vue?vue&type=script&lang=js"
import style0 from "./RightsCard.vue?vue&type=style&index=0&id=5251d128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251d128",
  null
  
)

export default component.exports